
<template>
  <div class="row gy-2">
    <div class="col-12">
      <h5 class="mb-3">Explore Open Jobs for Application</h5>
      <div class="row mb-3 gy-2 justify-content-between">
        <div class="col-md-6 col-lg-4">
          <div class="input-group w-auto">
            <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage" :options="pageOptions"></b-form-select>
          </div>
        </div>
        <div class="col-md-5">
          <div class="input-group mb-0">
            <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control" placeholder="Search here..." aria-label="Search here..." aria-describedby="button-search_TB">
            <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span class="ri ri-search-line"></span></button>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <p class="mb-0">Showing {{paginationInfo}} results</p>
      </div>
      <is-loading v-if="isLoading" :box="true" />
      <div v-else class="row g-4">
        <div v-for="(opportunity, oppIndex) in pageData.data" :key="oppIndex"
              class="col-xxl-3 col-sm-6">
            <open-opportunity-card :item="opportunity"></open-opportunity-card>
        </div>
        <p v-if="!pageData.data.length" class="text-center">There are no jobs available at the moment</p>
        <div class="mb-4">
          <b-pagination v-model="currentPage" :limit="4" class="pagination-rounded"
          :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import _ from 'lodash';
import { commonSortingMixin } from '@/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';
import OpenOpportunityCard from '@/components/cards/OpenOpportunityCard.vue';

export default {
  name: "opportunities",
  mixins:[
    commonSortingMixin,
    commonPaginationMixin,
  ],
  components:{
    IsLoading,
    OpenOpportunityCard,
  },
  data() {
    return {
      isLoading: true,
      searchQuery: "",
      sortBy: {
        sort_column: "created_at",
        sort_direction: "desc"
      },
      pageData:{
        data: []
      }
    }
  },
  computed: {
    activeUser(){
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    updateSearchQuery: _.debounce(function(string) {
      this.fetchItems()
    }, 2000),
    fetchItems(page, per_page = null){
      let payload = {page: page || 1, per_page: per_page || this.itemsPerPage,
        ...this.sortBy
      }
      if(this.searchQuery){ payload.search = this.searchQuery }
      this.isLoading = true
      this.$http.get(`/opportunities?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          this.isLoading = false
          if(response.data.success){
            this.pageData = response.data.data
            this.initializeAll();
          }
        })
    },
    initializeAll(){
        
    }
  },
  created() {
    this.fetchItems()
  }
}

</script>

